import { Link } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import PageHero from '@/components/feature/PageHero';
import { diseases } from '@/mocks/home';
import { fetchDiseaseList } from '@/services/disease';
import { adaptDiseases } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';
import type { DiseaseItem } from '@/types/content';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=Close%20up%20still%20life%20of%20traditional%20Chinese%20herbal%20medicine%20ingredients%20arranged%20in%20a%20wooden%20tray%20beside%20a%20porcelain%20tea%20cup%2C%20warm%20amber%20tones%2C%20dark%20soft%20shadowed%20lower%20area%20for%20text%20overlay%2C%20cinematic%20editorial%20photography&width=1920&height=560&seq=diseases-hero&orientation=landscape';

export default function DiseasesPage() {
  // 接口失败时降级为 mock 数据
  const { data: diseaseList } = useRequest<DiseaseItem[]>(
    () => fetchDiseaseList({ pageIndex: 1, pageSize: 999 }).then((res) => adaptDiseases(res.list)),
    { fallback: diseases },
  );

  return (
    <PageShell>
      <PageHero
        image={HERO_IMAGE}
        eyebrow="优势病种"
        title="中西医结合优势病种"
        description="聚焦国家重点推广的优势病种中西医结合诊疗方案，以规范化诊疗方案与系统化辨证思路，帮助医师与患者系统了解辨证思路与调理路径。"
        breadcrumb={[{ label: '首页', to: '/' }, { label: '优势病种' }]}
      />

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {diseaseList.map((item) => (
              <Link
                key={item.id}
                to={`/diseases/${item.id}`}
                className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="relative w-full h-[190px] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.name}
                    title={`${item.name} - 优势病种`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/90 backdrop-blur text-xs font-medium text-accent-700">
                    优势病种
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-5">
                  <h3 className="font-heading font-semibold text-lg text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.name}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.symptom}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                    查看图文详情
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}